import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Genera un PDF A4 a partir de un elemento DOM que contiene N secciones .page (una por hoja).
// Cada .page se captura por separado con html2canvas y se inserta como una pagina del PDF.
//
// Uso:
//   const blob = await generarPresupuestoPdf(refToTemplate, "Propuesta-2026-1234.pdf", { download: true });
//
// Devuelve un Blob del PDF (util para subir despues a Firebase Storage en el paso 4).

export async function generarPresupuestoPdf(rootEl, filename, { download = true } = {}) {
  if (!rootEl) throw new Error("generarPresupuestoPdf: rootEl es requerido");

  const pages = rootEl.querySelectorAll(".page");
  if (pages.length === 0) throw new Error("generarPresupuestoPdf: no se encontraron paginas .page en el elemento");

  const pdf = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < pages.length; i++) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      // logging: false, // comentar si se necesita debug
    });
    const img = canvas.toDataURL("image/jpeg", 0.92);
    if (i > 0) pdf.addPage();
    pdf.addImage(img, "JPEG", 0, 0, pageW, pageH);
  }

  if (download) {
    pdf.save(filename);
  }

  return pdf.output("blob");
}
